import axios from 'axios';
import { DropdownOption, DropdownResponse } from '../types/dropdown';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://192.168.2.237:5139/api';

class DropdownService {
  private api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  constructor() {
    // 請求攔截器 - 添加 token
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 響應攔截器 - 處理 401 錯誤
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userInfo');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  // 獲取所有下拉選單選項
  async getAllOptions(): Promise<DropdownResponse> {
    const response = await this.api.get('/dropdown/all');
    return response.data;
  }

  // 獲取混凝土供應商
  async getConcreteSuppliers(): Promise<DropdownOption[]> {
    const response = await this.api.get('/dropdown/concrete-suppliers');
    return response.data;
  }

  // 獲取攪拌廠位置
  async getMixingPlantLocations(): Promise<DropdownOption[]> {
    const response = await this.api.get('/dropdown/mixing-plant-locations');
    return response.data;
  }

  // 獲取 CON PFA 來源
  async getConPfaSources(): Promise<DropdownOption[]> {
    const response = await this.api.get('/dropdown/con-pfa-sources');
    return response.data;
  }

  async getMaterialSources(): Promise<DropdownResponse> {
    const response = await this.api.get('/dropdown/material-sources');
    return response.data;
  }
}

export const dropdownService = new DropdownService();